import { ApiShopperLandingPage } from '@storefronts/common-types'
import Script from 'next/script'

export const TaboolaPixel: React.FC<{ landingPage: ApiShopperLandingPage }> = ({
    landingPage,
}) => {
    if (!landingPage.integrations.taboolaPixelId) return null

    return (
        <Script id="taboola-pixel" strategy="afterInteractive">
            {`
                window._tfa = window._tfa || [];
                window._tfa.push({notify: 'event', name: 'page_view', id: ${parseInt(landingPage.integrations.taboolaPixelId, 10)}});
                !function (t, f, a, x) {
                    if (!document.getElementById(x)) {
                        t.async = 1;t.src = a;t.id=x;f.parentNode.insertBefore(t, f);
                    }
                }(document.createElement('script'),
                document.getElementsByTagName('script')[0],
                '//cdn.taboola.com/libtrc/unip/${landingPage.integrations.taboolaPixelId}/tfa.js',
                'tb_tfa_script');
            `}
        </Script>
    )
}
